import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TestsService extends ApiService {
	constructor() {
		super();
	}

	public loginProfile(body: {
		api_key: string;
		profile_uuid: string;
		short_url_pwcs: boolean;
		token_duration_minutes?: number;
		match_data?: any;
	}): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/auth`, body, {
			headers: this.getPublicHeaders(),
		});
	}

	public getInfoGemini(image: string): Observable<any> {
		return this.http.post<any>(
			environment.identity2 + `/ocr/simple`,
			{ image: image },
			{
				headers: this.getHeadersSimple(),
			},
		);
	}
}
